import { FC } from 'react';

import { CHART_HEIGHT_PX } from '../AnalyticsStackedTimeSeriesBox.utils';

export const AnalyticsStackedTimeSeriesEmptyChartState: FC = () => (
  <div
    data-testid="analytics-stacked-time-series-box-empty-state"
    style={{ height: CHART_HEIGHT_PX }}
    className="w-full flex items-center justify-center text-base-mutedForeground"
  >
    No results found
  </div>
);
